module.exports = "/_next/static/images/561bf16bc2907250c44aec9af0462c6b-thumbnail.jpg.webp";